<template>
    <base-card>
        <template #body>
            <div class="flex items-center">
                <div :class="[iconColor, iconBgColor]" class="flex-shrink-0 rounded-md p-3">
                    <icon :name="icon" class="h-6 w-6 text-white" stroke="currentColor" :fill="iconFill" />
                </div>
                <div class="ml-5 w-0 flex-1">
                    <dl>
                        <dt class="text-sm leading-5 font-medium text-gray-500 dark:text-gray-400 truncate">
                            {{ label }}
                        </dt>
                        <dd class="flex items-baseline">
                            <div class="text-2xl leading-8 font-semibold text-gray-900 dark:text-white">
                                {{ value }}
                            </div>
                            <div v-if="change" :class="increase ? 'text-green-500' : 'text-red-500'" class="ml-2 flex items-baseline text-sm leading-5 font-semibold">
                                <svg class="self-center flex-shrink-0 h-5 w-5 text-green-500" fill="currentColor" viewBox="0 0 20 20" v-if="increase">
                                    <path fill-rule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                                </svg>
                                <svg class="self-center flex-shrink-0 h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20" v-else>
                                    <path fill-rule="evenodd" d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
                                </svg>
                                <span class="sr-only">
                                    {{ increase ? 'Increased by' : 'Decreased by'}}
                                </span>
                                {{ change }}
                            </div>
                        </dd>
                    </dl>
                </div>
            </div>
        </template>
    </base-card>
</template>

<script>
import BaseCard from "../Base/Card";
export default {
    name: 'widget-stats',
    components: {BaseCard},

    props: {
        label: {
            type: String
        },
        value: {
            type: String
        },
        change: {
            Type: String
        },
        increase: {
            type: Boolean,
            default: true
        },
        icon: {
            type: String,
            default: 'chart-bar'
        },
        iconColor: {
            type: String,
            default: 'text-white'
        },
        iconFill: {
            type: String,
            default: 'rgba(255,255,255,0.2)'
        },
        iconBgFrom: {
            type: String,
            default: 'from-blue-400'
        },
        iconBgTo: {
            type: String,
            default: 'to-indigo-500'
        },
    },

    computed: {
        iconBgColor() {
            if (this.iconBgFrom !== '' && this.iconBgTo !== '') {
                return `bg-gradient-to-r ${this.iconBgFrom} ${this.iconBgTo}`
            }

            return 'bg-gray-700';
        }
    },
}
</script>
